import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SearchUnitDepartureAirport from 'components/SearchUnitDepartureAirport/SearchUnitDepartureAirport';
import * as appStateActions from 'actions/appStateActions';
import * as customControlActions from 'actions/customControlActions';
import * as searchUnitActions from 'actions/searchUnitActions';

const mapStateToProps = state => ({
  appState: state.appState,
  baseState: state.baseState,
  dimensionsEntities: state.dimensionsEntities,
  dimensionsResult: state.dimensionsResult,
});

const mapDispatchToProps = dispatch => ({
  appStateActionsBound: bindActionCreators(appStateActions, dispatch),
  customControlActionsBound: bindActionCreators(customControlActions, dispatch),
  searchUnitActionsBound: bindActionCreators(searchUnitActions, dispatch),
});

export class SearchUnitDepartureAirportLayout extends Component {
  static propTypes = {
    appState: PropTypes.object.isRequired,
    appStateActionsBound: PropTypes.object.isRequired,
    baseState: PropTypes.object.isRequired,
    customControlActionsBound: PropTypes.object.isRequired,
    searchUnitActionsBound: PropTypes.object.isRequired,
    dimensionsEntities: PropTypes.object.isRequired,
    dimensionsResult: PropTypes.object.isRequired,
  };

  getAllOutboundAirports() {
    const { baseState, dimensionsEntities, dimensionsResult } = this.props;
    const availableAirportIds = dimensionsResult.get('D_DepartureAirport');
    const availableAirports = [];

    availableAirports.push({
      label: 'Any',
      value: '-1',
      checked: false,
      unavailable: false,
    });

    if (availableAirportIds) {
      availableAirportIds.map((dimId) => {
        const obj = dimensionsEntities.get(`${dimId}`);
        const departureAirports = baseState.get('D_DepartureAirport');
        availableAirports.push({
          label: `${obj.get('label')}`,
          value: `${dimId}`,
          checked: departureAirports ? departureAirports.includes(dimId) : false,
          unavailable: !obj.get('available'),
        });
      });
    }

    return availableAirports;
  }

  onDepartureAirportClick = (airport) => {
    const {
      searchUnitActionsBound,
    } = this.props;


    searchUnitActionsBound.addDepartureAirport(Number(airport.value));
  };

  onRemoveDepartureAirport = (airport) => {
    const {
      searchUnitActionsBound,
    } = this.props;


    searchUnitActionsBound.removeDepartureAirport(Number(airport.value));
  };

  render() {
    return (
      <div className="search-unit-departure-airport-layout">
        <SearchUnitDepartureAirport
          options={this.getAllOutboundAirports()}
          addDepartureAirport={this.onDepartureAirportClick}
          removeDepartureAirport={this.onRemoveDepartureAirport}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUnitDepartureAirportLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/SearchUnitDepartureAirportLayout/SearchUnitDepartureAirportLayout.jsx
 **/